// Per-page title, description, canonical URL and link-preview (Open Graph / Twitter) tags.
// The router calls applySeo() after every navigation; a page can refine its own title later with setPageMeta()
// (BlogDetail does this once the article has loaded). Signed-in and account pages get "noindex".
const SITE = 'https://paperspotlight.com'
const IMAGE = SITE + '/share.jpg'
const DEFAULT_DESC = 'PaperSpotlight brings published research to the researchers who should read it, and measures where it is seen and cited.'

const PAGES = {
    '/': {
        title: 'PaperSpotlight | Academic Networking for Published Research',
        description: 'Let your paper dance into the light. PaperSpotlight brings published research to the researchers who should read it, and measures where it is seen and cited.',
        canonical: '/'
    },
    '/Authors': { same: '/' },
    '/journalsAndPublishers': {
        title: 'Journals & Publishers | PaperSpotlight',
        description: 'The intelligent engine behind leading journals: press releases to 800+ media outlets, audio distribution, GEO optimization for AI search and indexing support.'
    },
    '/partnerJournals': {
        title: 'Partner Journals | PaperSpotlight',
        description: 'The journals we work with directly and our wider network: 10,000+ curated partner journals and 80,000+ partner-integrated journals worldwide.'
    },
    '/AnalysisAndInsights': {
        title: 'Analysis & Insights | PaperSpotlight',
        description: 'Observations on how scholarly work circulates, gains attention and is read, and real cases with Google Scholar citations before and after a year of service.'
    },
    // every /BlogDetail/<id> article uses these until the article has loaded (BlogDetail then sets its own)
    '/BlogDetail': {
        title: 'Analysis & Insights | PaperSpotlight',
        description: 'Observations on how scholarly work circulates, gains attention and is read.'
    },
    '/about': {
        title: 'About | PaperSpotlight',
        description: 'Every idea matters. Every paper counts. We help journals, publishers and researchers get published work in front of the right readers, across disciplines and regions.'
    },
    '/faq': {
        title: 'FAQ | PaperSpotlight',
        description: 'Answers about PaperSpotlight: how the service works, plans and papers, academic integrity, results, billing and refunds, and your data.'
    },
    '/news': {
        lang: 'zh-CN',
        title: 'PaperSpotlight 简介',
        description: 'PaperSpotlight（简称 PSL）是一家成立于2015年的国际性学术出版服务机构，提供论文发表后的内容分发与读者拓展相关支持。'
    },
    '/guidePage': {
        title: 'Free Assessment | PaperSpotlight',
        description: 'Answer a few questions about your field, your papers and your citation goals, and get a recommended campaign plan for your research.'
    },
    '/teamsOfService': { title: 'Terms of Service | PaperSpotlight', description: DEFAULT_DESC },
    '/login': { title: 'Log In | PaperSpotlight', noindex: true },
    '/register': { title: 'Create Account | PaperSpotlight', noindex: true },
    '/resetPassword': { title: 'Reset Password | PaperSpotlight', noindex: true },
    '/bindEmail': { title: 'Connect Your Email | PaperSpotlight', noindex: true },
    '/unsubscribeEmail': { title: 'Unsubscribe | PaperSpotlight', noindex: true }
}

function tag(selector, create) {
    let el = document.head.querySelector(selector)
    if (!el) { el = create(); document.head.appendChild(el) }
    return el
}
function setMeta(attr, key, content) {
    const el = tag(`meta[${attr}="${key}"]`, () => { const m = document.createElement('meta'); m.setAttribute(attr, key); return m })
    el.setAttribute('content', content)
}
function setLink(rel, href) {
    tag(`link[rel="${rel}"]`, () => { const l = document.createElement('link'); l.setAttribute('rel', rel); return l }).setAttribute('href', href)
}

// write the tags for one page
export function setPageMeta({ title, description, url, noindex, image }) {
    if (title) {
        document.title = title
        setMeta('property', 'og:title', title)
        setMeta('name', 'twitter:title', title)
    }
    if (description) {
        setMeta('name', 'description', description)
        setMeta('property', 'og:description', description)
        setMeta('name', 'twitter:description', description)
    }
    if (url) {
        setLink('canonical', url)
        setMeta('property', 'og:url', url)
    }
    setMeta('property', 'og:image', image || IMAGE)
    setMeta('name', 'twitter:image', image || IMAGE)
    setMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow')
}

export const SITE_URL = SITE
export function applySeo(route) {
    const article = /^\/BlogDetail\/[^/]+$/.test(route.path)
    let page = PAGES[article ? '/BlogDetail' : route.path]
    if (page && page.same) page = PAGES[page.same]
    if (!page) {
        // the signed-in area (dashboard, papers, plans ...) and anything else: not for search engines
        setPageMeta({ title: 'PaperSpotlight', description: DEFAULT_DESC, url: SITE + route.path, noindex: true })
        return
    }
    let path = page.canonical || route.path
    // an old article link (/BlogDetail?caseId=86) points search engines to the article's own address
    if (route.path === '/BlogDetail' && route.query.caseId) path = '/BlogDetail/' + encodeURIComponent(route.query.caseId)
    document.documentElement.lang = page.lang || 'en'
    setPageMeta({ title: page.title, description: page.description || DEFAULT_DESC, url: SITE + path, noindex: !!page.noindex })
}
